'use client'

import { mockServices } from '@/app/mock_services'
import { ServiceDetail } from '@/types/interfaces'
import { useEffect, useState } from 'react'
import { ServiceCard } from './card-service'

export const GridServices = () => {
  const [servicesData, setServicesData] = useState<ServiceDetail[]>([])
  const [loading, setLoading] = useState(true)

  const getServices = async (): Promise<ServiceDetail[]> => {
    return mockServices
  }

  useEffect(() => {
    const loadServices = async () => {
      const listServices = await getServices()
      setServicesData(listServices)
      setLoading(false)
    }

    loadServices()
  }, [])

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {!loading ? (
        servicesData.map((service, index) => <ServiceCard key={index} detail={service} />)
      ) : (
        <p>Caricamento in corso...</p>
      )}
    </div>
  )
}
